var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info.error)?_c('section',{staticClass:"error"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.info.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }